import React, { Component } from "react";
import axios from "axios";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export class MaintenanceMessage extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      collapse: true,
      message: [],
      delay: 600000,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.pollForMessage();
    this.interval = setInterval(this.pollForMessage, this.state.delay);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.delay !== this.state.delay) {
      clearInterval(this.interval);
      this.interval = setInterval(this.pollForMessage, this.state.delay);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.interval);
  }

  pollForMessage = () => {
    var randomNumber = Math.floor(Math.random() * 1000000);
    axios.get(`${process.env.PUBLIC_URL}/message.json?v=` + randomNumber).then(
      (res) => {
        if (this._isMounted && typeof res.data?.message === "string") {
          this.setState({ message: res.data.message });
        }
      },
      // Rejection handler rather than .catch, so it sees the request failing
      // but never an error thrown by the handler above. Best-effort poll: the
      // banner keeps its current state until the next tick.
      () => {},
    );
  };

  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  render() {
    if (this.state.message.length > 0) {
      return (
        <div>
          <span className="p-2" id="importantInfoIcon">
            <FontAwesomeIcon
              title="Info"
              icon="triangle-exclamation"
              style={{ cursor: "pointer" }}
              onClick={this.toggle}
            />
          </span>
          <Collapse
            isOpen={this.state.collapse}
            tag="h4"
            className="border-top border-bottom p-2"
            id="importantInfoText"
          >
            <span className="pe-2 ps-2">
              <FontAwesomeIcon
                title="close"
                icon="xmark"
                style={{ cursor: "pointer" }}
                onClick={this.toggle}
              />
            </span>
            {this.state.message}
          </Collapse>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default MaintenanceMessage;
